import React, { useEffect } from "react";
import Lottie from "react-lottie";
import { Content, Subtitle, Wrapper } from "./styles";
import * as animationData from "../../../assets/animations/loading.json";
import Authentication from "../../../../infra/cognito/authentication";

const ExitPage = (): JSX.Element => {
  useEffect(() => {
    (async () => {
      await Authentication.logout();
    })();
  }, []);
  return (
    <Wrapper>
      <Content>
        <Subtitle>Até Mais</Subtitle>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          height={20}
          width={100}
          isStopped={false}
          isPaused={false}
        />
      </Content>
    </Wrapper>
  );
};
export default ExitPage;
